<div fxLayout="column" fxFlexFill *ngIf="!loader">
  <div class="divider layout-padd-1" *ngIf="currMerchant" ngClass.xs="layout-padd" fxLayoutAlign="start center"
    fxLayoutGap="10px">

    <button mat-icon-button (click)="goBack()">
      <mat-icon>arrow_back</mat-icon>
    </button>

    <div fxLayout="column">
      <span class="mat-title">{{currMerchant.denomination | capitalize | descFilter: 20}}</span>

    </div>

  </div>


  <div fxFlex class="scrolled">

    <div>



      <div fxLayout="column" class="layout-padd-credit-due" id="credits"
        *ngIf="client_creditsToPay$ && client_creditsToPay$.length>0">

        <mat-form-field appearance="outline" class="full-w"
          style="margin-bottom: -15px !important; margin-top: -5px !important;">
          <mat-label>{{"credit_history.point_of_sales"|translate }}</mat-label>
          <mat-select [(ngModel)]="selectedValue" (ngModelChange)="pofChange($event)">
            <mat-option *ngFor="let obj of client_creditsToPay$; let index = index"
              [value]="obj.point_of_sale?obj.point_of_sale.id:obj.value[0].point_of_sale &&obj.value[0].id_point_of_sale?obj.value[0].id_point_of_sale:null">
              {{obj.value[0].point_of_sale.denomination}}
            </mat-option>
          </mat-select>
        </mat-form-field>



        <div *ngFor="let obj of client_creditsToPay$;let i=index">
          <mat-card *ngIf="obj.pay_online && obj.point_of_sale&& selectedValue==obj.point_of_sale.id">

            <div style="margin-bottom: 10px;    overflow: auto; padding-right: 5px;"
              [ngClass.xs]="currMerchant?'heightContentxs':'heightContentxsNOMerchant'"
              [ngClass]="currMerchant?'heightContent':'heightContentNOMerchant'">

              <!-- <mat-card-title>{{obj.value[0].point_of_sale.denomination}}</mat-card-title> -->


              <mat-card-content id="content-{{i}}">


                <!-- checkbox -->

                <div fxLayout="row" fxLayoutAlign="end center" class="layout-padd ">
                  <mat-checkbox [checked]="obj.allcompleted" (change)="setAllComplete($event.checked,obj,i)"
                    [labelPosition]="'before'" [disabled]="!obj.pay_online">
                    <span style="padding-right: 25px;">
                      {{(!obj.allcompleted?"credit_due.check":"credit_due.uncheck") |translate}}
                    </span>
                  </mat-checkbox>
                </div>


                <!-- ligne credit -->
                <div *ngFor="let credit of obj.value">

                  <div fxLayout="row" class="layout-padd bold " fxLayoutGap="30px">

                    <div fxLayout="row" fxLayoutAlign="space-between center" fxFlex
                      [class.barre]="credit.lettering_payment" class="t">

                      <!-- goTicket -->
                      <div>
                        <mat-icon class="great-ico clicked" matTooltip="{{'credit_due.see_ticket'|translate}}"
                          matTooltipPosition="below" (click)="goPrintTicket(credit.link_ticket)" angulartics2On="click"
                          angularticsAction="openTicketWithcredit" angularticsCategory="clientNotes">print</mat-icon>
                      </div>


                      <!-- date et n° doc -->
                      <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-around center" fxLayoutGap.xs="5px"
                        fxFlex [class.boldest]="credit.completed">
                        <div> {{credit.date | dateFilter:"DD-MM-YYYY"}} </div>
                        <div> {{credit.n_document}} </div>
                      </div>

                      <!-- montant -->
                      <div [class.boldest]="credit.completed">
                        {{(credit.value * -1 ) | priceFilter:
                        credit.currency.symbol : credit.currency.decimal}}
                      </div>

                    </div>

                    <!-- checkbox -->
                    <div fxLayoutAlign.xs="start center">
                      <mat-checkbox [(ngModel)]="credit.completed" (ngModelChange)="updateComplete(obj,i)"
                        [disabled]="!obj.pay_online ||credit.lettering_payment" style="margin-top: -5px;">
                      </mat-checkbox>
                    </div>
                  </div>

                  <!-- contrainte -->
                  <!-- paiement effectué mais pas enregistré api connectil -->

                  <div *ngIf="credit.lettering_payment" class="warn-ico font14 pad-5-l bold" fxLayout="row"
                    fxLayoutAlign="space-between center" fxLayoutGap="10px">
                    <div>{{'credit_due.success_payment' |translate}}</div>
                    {{credit.lettering_payment.date | dateFilter:"DD-MM-YYYY"}} {{credit.lettering_payment.date |
                    dateFilter:"HH:mm"}}

                  </div>


                </div>


                <!-- contraintes -->
                <!-- pas  de moyen de paiement du pof -->
                <div class="warn-ico font14 pad-5-l" *ngIf="!obj.pay_online">
                  {{"credit_due.nosalemethods"|translate}}
                </div>
                <!-- montant negatif -->
                <div class="warn-ico font14 pad-5-l" *ngIf="obj.cumul>0">
                  {{"credit_due.neg_amount"|translate}}
                </div>





              </mat-card-content>
            </div>



           
                      

            <app-payments-methods-endorder [clientCards]="clientCards$" [currCard$]="currCard$"
              (setPaymentChoiceEvent)="setPaymentChoice_($event)" [creditMode]="'creditMode'"
              [clientCumul]="clientCumul" (openCardMethodsDialEvent)="openCardMethodsDial($event)" [currPOS]="currPOS"
              [payment_type]="payType" [currPaymentChoice]="currPaymentChoice">
            </app-payments-methods-endorder>


            <div class="bordered-card" style="margin-top: 10px" [class.dis]="obj.cumul>0"
              [class.isdiscolor]="obj.cumul==0" *ngIf="obj.pay_online">

              <!-- Amount -->
              <div fxLayout="row" fxLayoutAlign="space-between" class="layout-padd-credit-due">
                <span class="mat-subheading-1">Montant</span>
                <span class="mat-subheading-1 " [class.boldest]="obj.cumul<0"> {{(obj.cumul * -1 ) | priceFilter:
                  obj.value[0].currency.symbol : obj.value[0].currency.decimal}}</span>
              </div>
            </div>


            <mat-card-actions align="end" style="padding:0 !important; margin-bottom: 5px !important;"
              *ngIf="obj.pay_online">

              <!-- If paypal -->
            
              <app-confirm-credits (paypalEvent)="paypalEmited($event)" [credit_pay_intent]="credit_pay_intent"
                *ngIf="obj.payment_type=='online_paypal'"></app-confirm-credits>


              <div class="layout-padd-10-button">
                <button *ngIf="obj.payment_type!='online_paypal'" mat-raised-button color="primary"
                  angulartics2On="click" angularticsAction="beginNewOrder" angularticsCategory="preventLossUser"
                  [disabled]="obj.cumul>=0 ||!obj.pay_online" (click)="SubmitPay(obj)">
                  {{'button.pay'|translate}}

                </button>
              </div>


            </mat-card-actions>



          </mat-card>


          <mat-card fxLayout="row" fxLayoutAlign="center center" class="warn" *ngIf="!obj.pay_online && selectedValue &&  selectedValue==obj.value[0].id_point_of_sale">
            <div fxFlex="10%" fxLayoutAlign="start center">
              <mat-icon>warning</mat-icon>
            </div>
            <div fxFlex fxLayoutAlign="center center" class="text-center">
              <span class="mat-subheading-2">{{'credit_due.nosalemethods'|translate}}</span>
            </div>
          </mat-card>
        
        </div>
      </div>



      <div fxLayoutAlign="center center" class="layout-padd"
        *ngIf="!client_creditsToPay$  ||(client_creditsToPay$ && client_creditsToPay$.length < 1)">
        <span class="mat-subheading-1">{{'credit_history.no_credits'|translate}}</span>
      </div>



    </div>

  </div>





</div>




<app-popup-loader [flagLoading]="loader" [size]="30" [statusMessage]="('credit_due.'+statusMessageloader|translate)">
</app-popup-loader>